export const GET_ATTENDANCES = 'GET_ATTENDANCES';
export const GET_ATTENDANCES_SUCCESS = 'GET_ATTENDANCES_SUCCESS';
export const GET_ATTENDANCES_FAILED = 'GET_ATTENDANCES_FAILED';
export const GET_STUDENTS_LIST = 'GET_STUDENTS_LIST';
export const GET_STUDENTS_LIST_SUCCESS = 'GET_STUDENTS_LIST_SUCCESS';
export const GET_OLD_STUDENTS_LIST = "GET_OLD_STUDENTS_LIST";
export const GET_OLD_STUDENTS_LIST_SUCCESS = "GET_OLD_STUDENTS_LIST_SUCCESS";